export default () => {

  if ($('.resources-sticky-nav').length) {

    let stickyNavHeight;

    $(window).on('load resize', () => {
      stickyNavHeight = $('.resources-sticky-nav').height();
    });

    $(window).on('scroll', () => {
      const scrollDistance = $(window).scrollTop();

      // Assign active class to nav links while scolling
      $('.resource-item').map((index, el) => {
        if ($(el).position().top - stickyNavHeight - 30 <= scrollDistance) {
          $('.resources-sticky-nav a').removeClass('-active');
          $('.resources-sticky-nav a').eq(index).addClass('-active');
        }
      });
    });

    $('html').on('click', '.resources-sticky-nav a', function(event) {
      $('.resources-sticky-nav-dropdown-toggle').trigger('click');
      $(this).trigger('blur');

      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
        let target = $(this.hash);

        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - stickyNavHeight
          }, 500);
        }
      }
    });

  }

};
